export { LocalsOnlyModal as default } from './locals-only-modal';
export type { LocalsOnlyModalProps } from "./locals-only-modal";
